<script>
import Layout from "../../layouts/main";
import LocalInvoicesApi from "@/services/local-invoices-api";
import Swal from "sweetalert2";


import appConfig from "@/app.config";



export default {
  page: {
    title: "Service de Facturation ",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mounted(){

    this.role=sessionStorage.getItem("userr");

    this.getLocalInvoices();

    this.getCustomers();
  },

  components: { Layout },
  computed: {
    
  },
  data() {
    return {

      role : null,

      localInvoicesList: [],
      isTableLoading: false,
      selectedCustomer:null,
      invoice: {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0,taxStampValue:0,isTaxStampEnabled:false},
      invoiceLines: [{itemTitle: '', price: '', id:''}],
      itemsList: [],
      isDraftsTableLoading: false,
      isaddToInvoiceStarting:false,
      orderId : null ,
      showModel : false , 
      startDate:null,
      endDate:null,



      listFields: [
        
        { key:"dueDate", label: "Echeance",   sortable: false, tdClass:"font-weight-bold"},
        { key:"ref", label: "Numéro",thClass:"d-md-table-cell d-none",tdClass:"d-md-table-cell d-none" },
        { key:"customer.name", label: "Client", tdClass:"font-weight-bold"},
        { key:"submissionDate", label: "Date",   sortable: false},
        { key:"total", label: "Total HT",   thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none",},
        { key:"totalWithTaxes", label: "Total TTC",   thClass:"text-right d-md-table-cell d-none", tdClass:"text-right font-size-14 d-md-table-cell d-none",},
        { key:"status", label: "Etat",  thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none"},
        { key:"PaymentState", label: "Réglement",  thClass:"text-center ", tdClass:"text-center" ,thStyle:"width:100px;"},
        { key:"delete", label:"", tdClass: "text-right", thClass: "text-right", thStyle:"width:50px;"},
        { key:"download", label:"", tdClass: "text-right", thClass: "text-right", thStyle:"width:50px;"},
        { key:"actions", label:"", tdClass: "text-right", thClass: "text-right", thStyle:"width:50px;"}
        ],

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

        customersList: [],
    };
  }, 
  methods:{

    showModelDate(){
      this.showModel = true 

    },

    exportEXCEL(startDate , endDate){

      LocalInvoicesApi.exportEXCEL(startDate , endDate)
    },

    removeLocalInvoice(localInvoices){
      const localInvoice= {
        paymentState:!localInvoices.paymentState,
        invoiceId : localInvoices.id, 
        supplierId:  localInvoices.supplier.id,
      
      }

          Swal.fire({
          title: "Supprimer le brouillon ?",
          html: localInvoices.ref,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, supprimer!"
          }).then(result => {
          if (result.value) {
            this.deleteLocalInvoice(localInvoice)
            
          }
          });
          },

    changePaymentStateLocalInvoice(localInvoices){

      const localInvoice= {
        paymentState:!localInvoices.paymentState,
        invoiceId : localInvoices.id, 
        customerId: null,
        supplierId:  localInvoices.supplier.id,
        isSupplier:null ,
        dueDate: null,
      }

      Swal.fire({
        title: localInvoices.paymentState ?   "Facture non payée" :"Facture payée ? ",
        html: localInvoices.paymentState 
          ? "Changer l'état de la facture <strong>" + localInvoices.ref + "</strong> à non payée ?"
          : "Changer l'état de la facture <strong>" + localInvoices.ref + "</strong> à payée ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: localInvoices.paymentState ?  "Oui" :"Oui" 
      }).then(result => {
        if (result.value) {
          this.setPaymentLocalInvoice(localInvoice)
        }
      });
      
    },

    openLocalinvoice(localInvoice) {
      if (localInvoice.status !== 2) {
        this.$router.push({ path: '/newLocalInvoice', query: {  localInvoiceId: localInvoice.id } });
      } else {
        this.$router.push({ path: '/local-invoices/get', query: { localInvoiceId: localInvoice.id } });
      }
    },
    deleteLocalInvoice(localInvoice){
      LocalInvoicesApi.removeLocalInvoice(localInvoice)
            .then( result =>
              {
                this.invoice = result
              this.getLocalInvoices()
            }
            )

    },
    setPaymentLocalInvoice(localInvoice){
      LocalInvoicesApi.setPaymentLocalInvoice(localInvoice).then(
        result => {
          this.invoice = result
          this.getLocalInvoices()
        }
      )

    },


    editLocalInvoice() {
      const localInvoice= {
        paymentState:null,
        invoiceId : null, 
        customerId: null,
        supplierId: null,
        isSupplier:null ,
        dueDate: null,
      }
      
      this.isaddToInvoiceStarting=true
      LocalInvoicesApi.editLocalInvoice(localInvoice) 
      .then(invoice => {
        if(invoice) {
        
          this.invoiceLines = invoice.lines;
          this.invoice = invoice; 
          this.localInvoiceId = invoice.id;
          this.$router.push({ path: '/newLocalInvoice', query: { localInvoiceId: this.localInvoiceId } });

        }
        }).then(()=>{
          this.isaddToInvoiceStarting=false
        }).finally(()=>{
          this.isaddToInvoiceStarting=false
        })
    },

    downloadWithHolding(LocalInvoiceId, localInvoiceRef ){
      LocalInvoicesApi.getWithHolding(LocalInvoiceId , localInvoiceRef  )
    },
   
    getLocalInvoices() {
      this.isTableLoading = true

        LocalInvoicesApi.getAllBySupplier(this.pagemodel.currentPage, this.pagemodel.perPage, false, null, 
          this.selectedCustomer ? this.selectedCustomer.id : null , this.selectedCustomer ? this.selectedCustomer.isSupplier : null  )
      .then(invoices => {
        this.localInvoicesList = invoices.list
        this.pagemodel.totalRows = invoices.total;
        this.pagemodel.currentPage = invoices.page;
        this.pagemodel.perPage = invoices.pageSize;
        this.pagemodel.pageSize = invoices.pageSize;
      })
      .finally(() => {
        this.isTableLoading=false 
      })

      return;
    },

    getCustomers(){

      this.isCustomerListLoading = true;
      LocalInvoicesApi.findAllCustomersAndSuppliers().then(
            response => {    
              this.customersList = response;
            }
        )
      },

    statusToLabel(order) {
      switch(order.status) {
        case 0: return 'Brouillon';
        case 1: return 'Nouvelle';
        case 2: return 'Valide';
        case 3: return order.isDeliveryDone ? 'Livré' : 'En cours de Livraison';
        case 4: return 'Annulée';
        default: return '';
      }
    },

    statusToColor(order) {
      switch(order.status) {
        case 0: return 'secondary';
        case 1: return 'danger';
        case 2: return 'info'
        case 3: return order.isDeliveryDone ? 'success' : 'info';
        case 4: return 'secondary';
        default: return 'black';
      }
    },

},
    watch: {
      selectedCustomer: function() {
            this.getLocalInvoices();
        },
    }         
    }

</script>

<template>
  <Layout>
   
    <div class="row pt-4 pb-4">
      <div class="col-lg-12">
        <div class="card border border-primary">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">Service de Facturation</h2>

            <div  class="row mt-2">
                  <div v-if="role==1" class="col-sm-4 col-xs-6 pr-2">
                    <b-form-group label="Client" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="customersList" placeholder="Client" label="name" v-model="selectedCustomer">
                        <span slot="no-options">Aucun client dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>

                  <!-- <div v-if="role==1 || role==0" class="col-sm-4 col-xs-0"/>
                  <div class="col-sm-4 col-xs-0">
                    <b-form-group label="Etat" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="LocalInvoiceStatus" placeholder="Etat" label="name" v-model="selectedState" :searchable="false">
                        <span slot="no-options">Aucun etat dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div> -->
                </div>
                <div v-if="role==1" class="row ">
                  <div class="col-md-8 "></div>
                  <div class="col-md-2 col-6 text-right   mb-3 mt-1 "  >
                    <b-button variant="primary" @click="showModelDate()" style="width: 100%;" >
                      <i class="fas fa-file-excel   font-size-18 font-weight-bold align-middle mr-2"></i> <span class=" font-weight-bold">Etat de Facturation</span>
                    </b-button>
                  </div>
                  <div class="col-md-2 col-6 text-right pl-2 mb-3 mt-1"  >
                    <b-button variant="primary" @click="editLocalInvoice()" style="width: 100%;">
                      <i class="fas fa-plus-square font-size-18 font-weight-bold align-middle mr-2 w-350"></i> <span class=" font-weight-bold">Nouvelle Facture</span>
                    </b-button>
                  </div>
                </div>         
            <div>
    <div class="table-responsive mt-3" style="min-height:45em">        
        <b-table 
        :busy="isTableLoading"
        :striped="true"

        :small="false"
        :hover="true"

        :items="localInvoicesList"
        :fields="listFields"

        :perPage="pagemodel.perPage"
        class="table  "
        >
        <template v-slot:table-busy>
        <div class="text-center my-2">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
        </template>
        <template v-slot:cell(PaymentState)="{item}">
            <a v-if="item.status == 2" href="javascript:void(0);" class="action-icon font-size-16 text-info mr-2">
            <i v-b-tooltip.hover title="Payer"
              :class="item.paymentState ? 'text-success fa fa-check-circle' : 'text-danger fa fa-times-circle'"
              style="cursor: pointer;"
              @click="changePaymentStateLocalInvoice(item)"
              >
            </i>
          </a>       
        </template>
        <template v-slot:cell(delete)="{item}">
                <a v-if="item.status != 2" href="javascript:void(0);"  class="action-icon font-size-16 text-info mr-2" >
                  <i v-b-tooltip.hover title="Supprimer" 
                  class="mdi mdi-trash-can font-size-22 text-danger" 
                  style="cursor: pointer;"
                  @click="removeLocalInvoice(item)"></i></a> 
       </template>

        <template v-slot:cell(download)="{item}">
                <a v-if="item.linesCount != 0" href="javascript:void(0);"  class="action-icon font-size-16 text-info mr-2" @click="downloadWithHolding(item.id , item.ref)"><i v-b-tooltip.hover title="Télécharger" class="fas fa-download font-size-20 text-info"></i></a> 
       </template>

        <template v-slot:cell(actions)="{item}">
                <i v-b-tooltip.hover title="Ouvrir" style="cursor: pointer;" class="fas fa-file-import font-size-24 text-info" @click="openLocalinvoice(item)"></i>

        </template>

          <template v-slot:cell(status)="{item}">
            <h5><b-badge href="#" :variant="statusToColor(item)">{{statusToLabel(item)}}</b-badge></h5>
          </template>

          <template v-slot:cell(ref)="{item,value}">
            <span :class="item.status ==0 ? 'text-danger' : ''">{{value}}</span>
          </template>

          <template v-slot:cell(submissionDate)="{value}">
            <span>{{value}}</span>
          </template>
        </b-table>
        <span v-if="!isTableLoading && !localInvoicesList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune commande dans la liste</span>


    </div> 
    <div>
    <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getLocalInvoices()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodel.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :disabled="isTableLoading" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getLocalInvoices()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
 </div>
 </div>

          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showModel" 
    title="Etat de Facturation" 
    hide-footer 
    centered 
    title-class="text-warning"
    title-tag="h5"
    header-close-variant="danger"
    size="lg"
    no-close-on-backdrop>

    <div class="form-group row mb-3">
        <label class="col-md-3 col-form-label font-size-16" for="name">Période de l'état</label>
        <div class="col-md-4">
            <b-form-datepicker
                v-model="startDate"
                locale="fr"
                label-no-date-selected="Date Début"
                dark
            ></b-form-datepicker>
        </div>
        <div class="col-md-1"/>
        <div class="col-md-4">
            <b-form-datepicker
                v-model="endDate"
                locale="fr"
                label-no-date-selected="Date fin"
                :min="startDate"
                dark
            ></b-form-datepicker>
        </div>
    </div>

    <template >
        <b-button class="zoom-container text-right" variant="secondary" @click="showModel = false" size="md">Annuler</b-button>
        <b-button class="zoom-container text-right ml-2" variant="primary" @click="exportEXCEL(startDate, endDate)" :disabled="!startDate || !endDate">Générer</b-button>
    </template>
</b-modal>

  </Layout>
</template>